<template>
    <div class="col-md-12">
        <navbar placement="top" container="fluid">
                <div class="buttons-navbar-left" slot="left">
                    <img  src="../assets/img/logo_IASO.png" alt="Iaso-digital" width="90px">&nbsp;
                    <button :disabled="backDisabled" class="btn btn-info btn-sm" @click="back()" v-if="previousRouteData">{{ previousText }}</button>
                </div>
                <div class="buttons-navbar-right" slot="right">
                    <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{name: 'FreeGeneration', params: {previousText: 'Retour'}}">Générer une voix à partir d'un texte seul</router-link>
                    <router-link tag="button" class="btn btn-info btn-sm" type="button" :to="{name: 'FreeRecord', params: {previousText: 'Retour'}}">Enregistrer une voix hors texte</router-link>
                    <button class="btn btn-info btn-sm" @click="logout()">Déconnexion</button>
                </div>
        </navbar>
        <router-view class="col-md-10 col-md-offset-1" @navbarUpdate="onNavbarUpdate"></router-view>
    </div>
</template>

<script>
import { navbar as Navbar } from 'vue-strap'

export default {
    components: {
        Navbar
    },
    computed: {
    	previousText: function()	{
    		if (this.previousRouteData.text)	{
    			return this.previousRouteData.text != "" ? this.previousRouteData.text : 'Retour';
    		}
			return 'Retour';
    	}
    },
    methods: {
        onNavbarUpdate(previousRouteData)    {
            this.previousRouteData = previousRouteData;
        },
        back()  {
            if (this.previousRouteData.pathData)    {
                this.$router.push(this.previousRouteData.pathData);
            }
            else    {
                this.$router.back();
            }
            this.$nextTick(function()   {
                this.backDisabled = true;
            });
        },
        logout()    {
            this.$store.commit('TOKEN_UPDATED', "");
            localStorage.removeItem('token');
            localStorage.removeItem('refreshToken');
            this.$router.push('/');
        },
        refreshToken()  {
            let self = this;
            setTimeout(function() {
                let successCallback = (data) => {
                    self.$store.commit('TOKEN_UPDATED', {newToken: data.token, newRefreshToken: data.refresh_token});
                };

                let failCallback = (data) => {
                    self.$store.commit('TOKEN_UPDATED', {newToken: "", newRefreshToken: ""});
                    self.$router.push('/');
                };

                self.$store.dispatch('userRefresh', {success: successCallback, fail: failCallback, error: failCallback});
                self.refreshToken();
            }, 3600000);
        }
    },
    data: function()  {
        return {
            previousRouteData: null,
            backDisabled: false
        };
    },
    beforeCreate()  {
        this.$router.afterEach((to, from) => {
			this.previousRouteData = null;
            this.backDisabled = false;
            this.$Progress.finish();
        })
    },
    created() {
        if (!this.$store.state.admin.voicePresets) {
            this.$store.dispatch('getVoicePresets');
        }
    },
    mounted()   {
        this.refreshToken();
    }
}

</script>

<style>
.buttons-navbar-left   {
    margin-top:0.5em;
}

.buttons-navbar-right   {
    margin-top:0.5em;
    margin-right:1em;
}
</style>
